import { render, staticRenderFns } from "./MentoriasAbiertasListaItem.vue?vue&type=template&id=07801e16&"
import script from "./MentoriasAbiertasListaItem.vue?vue&type=script&lang=js&"
export * from "./MentoriasAbiertasListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports